import { List } from 'antd';
import React from 'react';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import moment from 'moment';

export default function ListMensagem(props: any) {
  const { mensagens } = props;

  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={mensagens}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={
                <a href="#">
                  {item.nomeDoUsuario + ' - ' + convertUTCtoLocal(moment(item.dataHoraInclusao)).toLocaleString()}
                </a>
              }
              description={item.mensagem}
              className={item.isMrn ? 'classeMrn' : 'classeFornecedor'}
            />
          </List.Item>
        )}
      />
    </div>
  );
}
